import R, { ap } from "ramda";
import * as RA from "ramda-adjunct";
import React from "react";
import PropTypes from "prop-types";
import jQuery from "jquery";
import moment from "moment";
import fellowshipjs from "./FellowshipAccord.js";
import loadScript from "./loadscript.js";

export default class FellowshipSearchItem extends React.Component {
  constructor(props) {
    super(props);
    this.itemWrapper = null;
    this.apiLoaded = false;
    this.id = props.buttonText.replace(/\s/g, '').toLowerCase();
  }


  componentDidMount() {
    console.log("FellowshipSearchItem mounted with ID:", this.id);
    fellowshipjs(this.id);
  }

  loadMapScript() {
    // Load the google maps api script when the component is mounted.

    console.log("Loading Fellowship JS");
    console.log(fellowshipjs);  
    loadScript(fellowshipjs).then((script) => {
        console.log("HJEDLE!");
        
        // Grab the script object in case it is ever needed.
        this.mapScript = script;
        this.setState({ apiLoaded: true });
        fellowshipjs();
        console.log(this.state.apiLoaded);
      })
      .catch((err) => {
        console.error(err.message);
      });
  }
  
  render() {
    const {
      buttonText,
      subtitle,
      rightTitle,
      rightSubtitle,
      description,
      columnList1,
      columnList2,
      columnList3,
      appNotesTitle,
      appNotesrawHTML,
    } = this.props;

    return (
      <div className="column-lists search-column-lists" id={buttonText.replace(/\s/g,'').toLowerCase()}>
        <div class="column-lists__accordion">
        <button className="column-lists__trigger js-simple-accordion">
          <div className="column-lists__top-text">
            <div className="column-lists__left-text">
              <span className="column-lists__plus-sign"></span>
              {buttonText}
              <h4 className="column-lists__subtitle">{subtitle}</h4>
            </div>
            <div className="column-lists__right-text">
              <h3 className="column-lists__right-title">{rightTitle}</h3>
              <h4 className="column-lists__right-subtitle">{rightSubtitle}{this.apiLoaded}</h4>
            </div>
          </div>
          
        </button>

        <div className="column-lists__body js-simple-accordion-target">
          <div className="column-lists__description">
            <p>{description}</p>
          </div>
          <div className="column-lists__row">
            <div className="column-lists__column">
              {columnList1.map((item, index) => (
                <div key={index}>
                  <h4>{item.listTitle}</h4>
                  <ul>
                    {item.contentItems.map((contentItem, idx) => (
                      <li key={idx}>{contentItem}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="column-lists__column">
              {columnList2.map((item, index) => (
                <div key={index}>
                  <h4>{item.listTitle}</h4>
                  <ul>
                    {item.contentItems.map((contentItem, idx) => (
                      <li key={idx}>{contentItem}</li>
                    ))}
                  </ul>
                  
                </div>
              ))}
            </div>

            <div className="column-lists__column">
              {columnList3.map((item, index) => (
                <div key={index}>
                  <h4>{item.listTitle}</h4>
                  <ul>
                    {item.contentItems.map((contentItem, idx) => (
                      <li key={idx}>{contentItem}</li>
                    ))}
                  </ul>
                  
                </div>
              ))}
            </div>

            <div className="column-lists__content">
                <h4>{ appNotesTitle }</h4>
                <div className="content-item">
                  <p>{ appNotesrawHTML }</p>
                </div>
            </div>
          </div>

           <a class="btn btn--secondary" href="#" role="button">
			Learn More
		</a>
        </div>
       
        </div>
      </div>
    );
  }
}

const { arrayOf, string } = PropTypes;
FellowshipSearchItem.propTypes = {
  buttonText: string.isRequired,
  subtitle: string.isRequired,
  rightTitle: string.isRequired,
  rightSubtitle: string.isRequired,
  description: string.isRequired,
  columnList1: arrayOf(PropTypes.shape({

      listTitle: string.isRequired,
      contentItems: arrayOf(string).isRequired,

  })).isRequired,
  columnList2: arrayOf(PropTypes.shape({

      listTitle: string.isRequired,
      contentItems: arrayOf(string).isRequired,

  })).isRequired,
  columnList3: arrayOf(PropTypes.shape({

      listTitle: string.isRequired,
      contentItems: arrayOf(string).isRequired,

  })).isRequired,
  appNotesTitle: string,
  appNotesrawHTML: string,

};
